import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceDeleteComponent } from './price-delete.component';



@NgModule({
  declarations: [
    PriceDeleteComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PriceDeleteComponent
  ]
})
export class PriceDeleteModule { }
